import React, { useState } from "react";
import { Button, Card, Form, InputGroup } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { updateDispatchWOStatus } from "../../Service/AllDispatchAPI";
import swal from "sweetalert"; 
import ToolTip from "../ToolTip";
const CloseDispatchForm = () => {
  const [workOrderNumber, setWorkOrderNumber] = useState("");
  const [comment, setComment] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!workOrderNumber || !comment) {
      swal("Error", "Please fill out all fields before submitting.", "error");
      return;
    }

    setIsSubmitting(true);

    const payload = {
      dispatchOrderNo: workOrderNumber,
      cloureRemark: comment,
    };

    const token = sessionStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await updateDispatchWOStatus(payload, headers);
      console.log("Response:", response);

      if (response.data === "Dispatch WO is Already Closed") {
        swal("Info", `Dispatch WO "${workOrderNumber}" is Already Closed`, "info");
        setWorkOrderNumber("");
        setComment("");
      } else if (response.data === "Dispatch WO Did Not Found") {
        swal("Error", "Dispatch WO Did Not Found", "error");
        setWorkOrderNumber("");
        setComment("");
      } else if (response.data === "Dispatch WO has been close") {
        swal("Great", `Dispatch WO "${workOrderNumber}" has been close.`, "success");
        setWorkOrderNumber("");
        setComment("");
      }

      
      setWorkOrderNumber("");
      setComment("");

    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Error Response:", error.response.data); 
        swal("Error", error.response.data || "Failed to close the dispatch order.", "error");
      } else {
        swal("Error", "An unexpected error occurred.", "error");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    window.location.href = "dispatchx/dispatch-list";
  };

  return (
    isVisible && (
      <Card className="p-4 w-100" style={{ maxWidth: "500px", margin: "auto", marginBottom: "10px" }}>
        <div className="d-flex justify-content-between mb-4">
          <h3 className="closuretitile">Dispatch WO Closure Form</h3>
         
        
          <Button variant="link" onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
          </Button> 
         
        </div>
        <Form onSubmit={handleSubmit}>


          <Form.Group id="workOrderNumber" className="mb-3">
            <Form.Label>Dispatch WO Number</Form.Label>
            <InputGroup className="d-flex">
              <Form.Control
                type="text"
                placeholder="Enter Dispatch WO Number"
                value={workOrderNumber}
                onChange={(e) => setWorkOrderNumber(e.target.value.replace(/\s/g, ""))} 
                required
              />
            </InputGroup>
          </Form.Group>

     
          <Form.Group id="comment" className="mb-3">
            <Form.Label>Dispatch WO Closure Remark</Form.Label>
            <InputGroup>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter Dispatch WO Closure Remark..."
                value={comment}
                maxLength={100}
                onChange={(e) => setComment(e.target.value)}
                required
              />
            </InputGroup>
          </Form.Group>

         
            <Button
              variant="primary"
              type="submit"
              className="w-30"
              disabled={isSubmitting || !workOrderNumber || !comment}
            >
              {isSubmitting ? "Please wait..." : "Close Dispatch WO"}
            </Button>
         
        </Form>
      </Card>
    )
  );
};

export default CloseDispatchForm;

